module.exports = __webpack_public_path__ + "static/media/3mf-header-banner.71b62605.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/3mf-header-banner.svg
 ** module id = 1293
 ** module chunks = 0
 **/